export default {
  name: 'en',
};
